import { PortalApp } from "@wexinc/wex-common-web";
import { Button, Heading, ArrowUpRightFromSquareIcon } from "@wexinc/wex-ui";
import classNames from "classnames";
import React from "react";

interface Props {
  app: PortalApp;
  className?: string;
}

function openPortalApp(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}

export const BasicCard: React.FC<Props> = (props) => {
  return (
    <div className="w-[300px]">
      <div
        className={classNames(
          "cursor-pointer shadow-elevation-1 border-2 border-utility-white hover:border-primary-30 hover:shadow-elevation-3 p-6 bg-utility-white rounded-lg",
          props.className,
        )}
        onClick={() => props.app.url !== "#" && openPortalApp(props.app.url!)}
        data-test-id={`launch-app-${props.app.id}`}
      >
        <div className="flex items-center text-neutral-dark-70">
          {React.cloneElement(props.app.icon, {
            className: "stroke-neutral-dark-60 shrink-0 h-6 w-6",
          })}
          <Heading
            size="medium"
            className="pl-2 line-clamp-1"
          >
            {props.app.title}
          </Heading>
        </div>
        <p className="pt-2 line-clamp-2 h-14">{props.app.description}</p>
        <div className="text-primary-50 flex items-center ml-auto mr-0 w-17 mt-6">
          Launch
          <ArrowUpRightFromSquareIcon
            width={12}
            height={12}
            className="fill-current ml-2"
          />
        </div>
      </div>
    </div>
  );
};

export const FeaturedCard: React.FC<Props> = (props) => {
  return (
    <div className="shadow-elevation-1 bg-utility-white rounded-lg flex">
      <div className="p-6 ">
        <div className="flex items-center text-neutral-dark-70">
          {React.cloneElement(props.app.icon, {
            className: "fill-neutral-dark-60",
          })}
          <Heading
            size="large"
            className="pl-2"
          >
            {props.app.title}
          </Heading>
        </div>
        <p className="pt-2 pb-4">{props.app.description}</p>
        <Button
          testId="launch-featured-app"
          onClick={() => props.app.url !== "#" && openPortalApp(props.app.url!)}
        >
          {props.app.launchButtonText || "Launch"}
          <ArrowUpRightFromSquareIcon className="ml-2 fill-current" />
        </Button>
      </div>
      {props.app.teaserImagePath && (
        <span className=" w-full h-full pt-6 -mr-2">
          <img
            src={props.app.teaserImagePath}
            style={{ boxShadow: "0px 0px 8px 1px rgb(2 13 36 / 15%)" }}
            className="rounded-lg"
            alt="teaser"
          />
        </span>
      )}
    </div>
  );
};
